import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/registration/Tick-GIF.gif'


const _withScopeId = (n: any) => (_pushScopeId("data-v-3ef3101b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "success-message",
  "data-test": "success-message"
}
const _hoisted_2 = { class: "success" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "success tick",
  class: "tick-gif",
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Success!", -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'success-message',
  props: {
    actionSuccess: { type: Boolean },
    detailChanged: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_ctx.actionSuccess)
    ? (_openBlock(), _createElementBlock("article", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("p", null, "You have successfully changed your " + _toDisplayString(_ctx.detailChanged), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})